const parseFromLocalStorage = <T>(key: string): T | null => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const parsed: T = JSON.parse(item);
    return parsed;
  } catch {
    return null;
  }
};

export default parseFromLocalStorage;
